module.exports = __webpack_public_path__ + "img/599275-2500x1667.92f1739f.jpg";